import { useQuery } from "@tanstack/react-query";
import { Plug } from "lucide-react";
import type { FC } from "react";
import React from "react";

import { bindArgs } from "@core/foundation/function";

import { ErrorView, LoadingView } from "@react/foundation/placeholder";
import { Button } from "@react/ui-primitives/button";

import { PageView } from "../../../shared/components/PageView.tsx";
import { useQueries } from "../../../shared/hooks/useQueries.ts";
import { useGithubActions } from "../hooks/useGithubActions.ts";

import { GithubConnectionCard } from "./GithubConnectionCard.tsx";

export const GithubConnectionsView: FC = () => {
  const { getGithubConnectionsQueryOptions } = useQueries();
  const githubConnections = useQuery(getGithubConnectionsQueryOptions());

  const { connect } = useGithubActions();

  if (githubConnections.status === "pending") {
    return <LoadingView />;
  }

  if (githubConnections.status === "error") {
    return <ErrorView description="Failed to load connections." />;
  }

  return (
    <PageView
      actions={
        <Button disabled={connect.isPending} onClick={bindArgs(connect.mutate)}>
          Connect GitHub
        </Button>
      }
      icon={<Plug />}
      subtitle="Connect your GitHub account and repositories."
      title="Connections"
    >
      <div className="flex flex-col gap-2">
        {githubConnections.data.items.map(({ githubConnection, repos }) => (
          <GithubConnectionCard
            githubConnection={githubConnection}
            key={githubConnection.githubAccountId}
            repoCount={repos.length}
          />
        ))}
      </div>
    </PageView>
  );
};
